import { isString } from 'lodash/fp';
import { isBoardLike, isColumn } from '../elements/utils/elementTypeUtils';
import { ElementType } from '../elements/elementTypes';
import { ColorObject } from './colorObjectUtil';
import { COLUMN_COLORS, ELEMENT_BACKGROUND_COLOR_HEX_VALUES } from './colorConstants';
import { getColorDefaultHexValue } from './elementColorFormatUtil';

const getThemeHex = ({ light, dark }: { light: string; dark: string }, isDarkMode: boolean): string =>
    isDarkMode ? dark : light;

/** Resolves semantic neutral presets to the value displayed by the custom colour picker. */
export const getElementColorPickerHexValue = ({
    color,
    elementType,
    isDarkMode,
    isBackground = false,
}: {
    color: string | ColorObject | null;
    elementType: ElementType;
    isDarkMode: boolean;
    isBackground?: boolean;
}): string | null => {
    if (!color) return null;
    if (!isString(color)) return getColorDefaultHexValue(color);

    if (color === 'CHARCOAL') {
        return getThemeHex(ELEMENT_BACKGROUND_COLOR_HEX_VALUES.CHARCOAL, isDarkMode);
    }

    if (color !== 'GREY') return getColorDefaultHexValue(color);

    if (isBackground && isColumn(elementType)) return COLUMN_COLORS.GREY.hex;

    const neutralColor = !isBackground && isBoardLike(elementType) ? 'CHARCOAL' : 'SILVER';
    return getThemeHex(ELEMENT_BACKGROUND_COLOR_HEX_VALUES[neutralColor], isDarkMode);
};
